import { render, staticRenderFns } from "./InformationCheckAndUseAgreement.vue?vue&type=template&id=5e802417&scoped=true"
import script from "./InformationCheckAndUseAgreement.vue?vue&type=script&lang=js"
export * from "./InformationCheckAndUseAgreement.vue?vue&type=script&lang=js"
import style0 from "./InformationCheckAndUseAgreement.vue?vue&type=style&index=0&id=5e802417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e802417",
  null
  
)

export default component.exports